module.exports = __webpack_public_path__ + "static/media/gh-map-enjoyment.cfd7a394.png";